//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { FormField } from '@campaigns/components/shared/product-details-modal/form/FormField';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { isValidImageUrl } from '@campaigns/constants/sampling/SamplingProductValidationRulesConstants';
import { EditableBVSamplingProduct } from '@campaigns/types/sampling/SamplingProductTypes';
import {
  SecondaryButton,
  TertiaryButton,
} from '@components/atoms/button/Button';

export interface UrlTabProps {
  index: number;
  rules: RegisterOptions | undefined;
  onClosePopover: () => void;
  onPreview: () => void;
}

export const UrlTab = ({
  index,
  onClosePopover,
  onPreview,
  rules,
}: UrlTabProps) => {
  const { setValue, watch } = useFormContext<EditableBVSamplingProduct>();
  const currentValue = watch(`variations.${index}.imgUrl`);

  const handleCancel = () => {
    setValue(`variations.${index}.imgUrl`, '');
    onClosePopover();
  };

  return (
    <Container>
      <FormField
        inputType='textarea'
        label='Image web address'
        name={`variations.${index}.imgUrl`}
        placeholder='https://your-awesome-website.com/030524.png'
        rules={rules}
      />
      <ActionButtons>
        <TertiaryButton
          onClick={handleCancel}
          trackingId={
            SAMPLING_CAMPAIGNS_TRACKING_ID.PRODUCT_MODAL_CANCEL_ADD_VARIANT_IMAGE_URL
          }
        >
          Cancel
        </TertiaryButton>
        <SecondaryButton
          isDisabled={!isValidImageUrl(currentValue)}
          onClick={onPreview}
          trackingId={
            SAMPLING_CAMPAIGNS_TRACKING_ID.PRODUCT_MODAL_CONFIRM_ADD_VARIANT_IMAGE_URL
          }
        >
          Add image
        </SecondaryButton>
      </ActionButtons>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[2]};
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacings[2]};
`;
